import React, { Fragment, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Table } from "reactstrap";
import { useTranslation } from "react-i18next";
import { Breadcrumbs } from "../../AbstractElements";
import { getStockItemDetails } from "./StockService";
import { useLoader } from "../../_helper/LoaderContext";
import { usePharmacy } from "../../_helper/PharmacyProvider";
import { FaArrowLeft } from "react-icons/fa";
import BarcodeDisplay from "../Common/Barcode/BarcodeDisplay";

const ViewStockItem = () => {
	const { stkId } = useParams();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { setLoading } = useLoader();
	const { pharmacyPOS } = usePharmacy();

	const [item, setItem] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const body = {
					clinicId: pharmacyPOS?.hospital_id,
					stockId: stkId,
				};
				const res = await getStockItemDetails(body);
				if (res?.data?.data) setItem(res.data.data);
			} catch (err) {
				console.error("Error fetching stock item:", err);
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, [stkId]);

	const formatDate = (dateString) => {
		if (!dateString) return "N/A";
		const date = new Date(dateString);
		const day = date.getDate().toString().padStart(2, '0');
		const month = date.toLocaleString(undefined, { month: 'short' });
		const year = date.getFullYear();
		return `${day} ${month} ${year}`; // Example: May 07, 2025
	};

	const statusText = (status) => (
		<span className={`fw-bold ${status ? "text-danger" : "text-success"}`}>
			{status ? t("Yes") : t("No")}
		</span>
	);

		// Totals calculation (NO TAX, ONLY DISCOUNT)
	const showCalculateItemSubtotal = (item) => {
		const base = item.unitPrice * item.totalMedicine;
		const discount = Number(item.discount) || 0;
		return base - discount >= 0 ? (base - discount).toFixed(2) : 0;
	};

	return (
		<Fragment>
			<Col sm="12">
				<Breadcrumbs
					mainTitle={t("Stock Item Details")}
					parent={t("Dashboard")}
					title={t("Stock Item Details")}
				/>
				<Card>
					<CardHeader className="d-flex justify-content-end">
						<button className="btn btn-primary" onClick={() => navigate(-1)}>
							<FaArrowLeft className="me-2" /> {t("Back")}
						</button>
					</CardHeader>
					<CardBody>
						{item ? (
							<div className="table-responsive">
								<Table className="table table-bordered">
									<tbody>
										<tr>
											<th>{t("Code")}</th>
											<td><strong>{item.code}</strong></td>
										</tr>
										{item.barcode && (
											<tr>
												<th>{t("Bar Code")}</th>
												<td>
													<BarcodeDisplay value={item.barcode} width={1.2} height={36} />
													<div className="small text-muted mt-1">{item.barcode}</div>
												</td>
											</tr>
										)}
										<tr>
											<th>{t("Product Name")}</th>
											<td>{item.brandName}</td>
										</tr>
										<tr>
											<th>{t("Manufacturer")}</th>
											<td>{item.manufacturerName}</td>
										</tr>
										<tr>
											<th>{t("Batch Number")}</th>
											<td>{item.batchNumber}</td>
										</tr>
										<tr>
											<th>{t("Purchase No")}</th>
											<td><strong>{item.purchaseNumber}</strong></td>
										</tr>
										<tr>
											<th>{t("Purchase Date")}</th>
											<td>{formatDate(item.createdAt)}</td>
										</tr>
										<tr>
											<th>{t("Expiry Date")}</th>
											<td>{formatDate(item.expiryDate)}</td>
										</tr>
										<tr>
											<th>{t("Package")}</th>
											<td>{item.package} ({item.packing})</td>
										</tr>
										<tr>
											<th>{t("Quantity")}</th>
											<td>{item.quantity}</td>
										</tr>
										<tr>
											<th>{t("Total Medicine")}</th>
											<td>{item.totalMedicine}</td>
										</tr>
										<tr>
											<th>{t("Remaining Medicine")}</th>
											<td className="fw-bold">{item.totalRemainingMedicine}</td>
										</tr>
										<tr>
											<th>{t("Unit Cost")}</th>
											<td>${item.unitPrice}</td>
										</tr>
										<tr>
											<th>{t("Unit Sale Price")}</th>
											<td>${item.unitPricePerMedicine}</td>
										</tr>
										<tr>
											<th>{t("Discount")}</th>
											<td>{item.discount}</td>
										</tr>
										<tr>
											<th>{t("Total Price")}</th>
											<td className="fw-bold text-primary">${showCalculateItemSubtotal(item)}</td>
										</tr>
										<tr>
											<th>{t("Expired")}</th>
											<td>{statusText(item.isExpired)}</td>
										</tr>
										<tr>
											<th>{t("Sold")}</th>
											<td>{statusText(item.isSold)}</td>
										</tr>
										{/* <tr>
											<th>{t("Created At")}</th>
											<td>{formatDate(item.createdAt)}</td>
										</tr>
										<tr>
											<th>{t("Updated At")}</th>
											<td>{formatDate(item.updatedAt)}</td>
										</tr> */}
									</tbody>
								</Table>
							</div>
						) : (
							<p>{t("Loading stock item details...")}</p>
						)}
					</CardBody>
				</Card>
			</Col>
		</Fragment>
	);
};

export default ViewStockItem;
